export default __webpack_public_path__ + "static/media/vscode.45b1618f.png";